// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.b-table[data-v-728e88ad] .table-wrapper {\n\toverflow-x: auto;\n}\n.b-table[data-v-728e88ad] .table {\n\tfont-size: 0.9rem;\n}\n.b-table[data-v-728e88ad] .table thead th {\n\tborder-bottom-width: 1px;\n}\n.b-table[data-v-728e88ad] .table td,\n.b-table[data-v-728e88ad] .table th {\n\tpadding: 0.5rem;\n}\n.b-table[data-v-728e88ad] .table tbody tr:last-child td {\n\tborder-bottom-width: 1px;\n}\n.b-table[data-v-728e88ad] .level {\n\tpadding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
